export function parseQueryString(input: string): Map<string, string> {
  let result = new Map<string, string>();

  if (typeof input !== "string") {
    return result;
  }

  input = input.trim().replace(/^[?#&]/, "");

  for (const param of input.split("&")) {
    let [key, value] = param.split("=");

    if (key) {
      value = value === undefined ? null : decodeURIComponent(value);
      result.set(decodeURIComponent(key), value);
    }
  }

  return result;
}
